export const PRIORITY_CONFIG = {
    High: {
        color: '#9B3629',
        borderColor: '#D84C3A',
        bgLight: '#FEF1EF',
        bgBadge: '#FFCEC8',
        icon: 'fa-circle-exclamation',
        label: 'High',
    },
    Medium: {
        color: '#9F762E',
        borderColor: '#ECB445',
        bgLight: '#FBF5E9',
        bgBadge: '#FCE6B7',
        icon: 'fa-triangle-exclamation',
        label: 'Medium',
    },
    Low: {
        color: '#59841E',
        borderColor: '#8DC63F',
        bgLight: '#F9FFF2',
        bgBadge: '#D1F1A7',
        icon: 'fa-circle-check',
        label: 'Low',
    },
};

export const PRIORITY_ORDER = { High: 1, Medium: 2, Low: 3 };

const PRIORITY_MAP = {
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    // numeric values some APIs return
    1: 'High',
    2: 'Medium',
    3: 'Low',
};
export const normalizePriority = (p) => {
    if (!p && p !== 0) return 'Low';
    return PRIORITY_MAP[String(p).toLowerCase()] || 'Low';
};

export const formatDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    try {
        // If no timezone indicator, the API returned a bare UTC string — append Z so
        // the browser converts it to the user's local time instead of treating it as local.
        const normalized = /Z|[+-]\d{2}:\d{2}$/.test(isoString)
            ? isoString
            : isoString + 'Z';
        const d = new Date(normalized);
        return d.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    } catch {
        return isoString;
    }
};

export const hasSupportBannerAccess = () => {
    const access = localStorage.getItem('hasSupportBannerAccess');
    if (access === 'true') return true;
    if (access === 'false') return false;
    try {
        const userDetails = JSON.parse(
            localStorage.getItem('user_details') || '{}'
        );
        if (userDetails.isSupportUser === true || userDetails.isAdmin === true)
            return true;
    } catch {
        // ignore
    }
    return localStorage.getItem('WV-Token') !== null;
};
